import React, { useEffect, useState } from 'react';
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TestimonialSlider from '../../components/v3/TestimonialSlider/TestimonialSlider';
import TruestedSection from '../../components/v4/TrustedSection/TruestedSection';
import LottieIcon from '../../components/v4/LottieIcon';

//animation
import aiChatbotAnimation from "../../animations/v3/aiFeatures/aiChatbotAnimation.json";

//images
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import arrowRight from "../../images/v4/salesReps/arrowRight.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";

import detailImg2 from "../../images/v4/aiSalesCrm/images/detailImg2.webp";

// import aiIcon from "../../images/v4/aiFeatures/aiChatbot/icons/aiIcon.svg";
import aiIcon from "../../images/v4/aiFeatures/aiChatbot/images/aiIcon.png";
import smileIcon from "../../images/v4/aiFeatures/aiSentiment/images/smileIcon.png";

import heroSectionBg from "../../images/v4/aiFeatures/aiSentiment/images/heroSectionBg.png";
import tabsSectionBg from "../../images/v4/aiFeatures/aiSentiment/images/tabsSectionBg.png";
import accordianTabsBg from "../../images/v4/aiFeatures/aiChatbot/images/accordianTabsBg.png";
import benefitSectionBg from "../../images/v4/aiFeatures/aiChatbot/images/benefitSectionBg.png";
import growingBusinessBg from "../../images/v4/aiFeatures/aiChatbot/images/growingBusinessBg.png";


import experienceImg1 from "../../images/v4/aiFeatures/aiChatbot/images/experienceImg1.webp";
import experienceImg2 from "../../images/v4/aiFeatures/aiChatbot/images/experienceImg2.webp";
import experienceImg3 from "../../images/v4/aiFeatures/aiChatbot/images/experienceImg3.webp";
import experienceImg4 from "../../images/v4/aiFeatures/aiChatbot/images/experienceImg4.webp";
import experienceImg5 from "../../images/v4/aiFeatures/aiChatbot/images/experienceImg5.webp";

import realWorldImg1 from "../../images/v4/aiFeatures/aiChatbot/images/realWorldImg1.webp";
import realWorldImg2 from "../../images/v4/aiFeatures/aiChatbot/images/realWorldImg2.webp";
import realWorldImg3 from "../../images/v4/aiFeatures/aiChatbot/images/realWorldImg3.webp";
import realWorldImg4 from "../../images/v4/aiFeatures/aiChatbot/images/realWorldImg4.webp";

import benefitIcon1 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon1.svg";
import benefitIcon2 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon2.svg";
import benefitIcon3 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon3.svg";
import benefitIcon4 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon4.svg";
import benefitIcon5 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon5.svg";
import benefitIcon6 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon6.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import heroIcon1 from "../../images/v4/aiFeatures/aiSentiment/icons/heroIcon1.svg";
import heroIcon2 from "../../images/v4/aiFeatures/aiSentiment/icons/heroIcon2.svg";
import heroIcon3 from "../../images/v4/aiFeatures/aiSentiment/icons/heroIcon3.svg";

import cardBg1 from "../../images/v4/aiFeatures/aiSentiment/images/cardBg1.png";
import cardBg2 from "../../images/v4/aiFeatures/aiSentiment/images/cardBg2.png";

import cardImg1 from "../../images/v4/aiFeatures/aiSentiment/images/cardImg1.webp";
import cardImg2 from "../../images/v4/aiFeatures/aiSentiment/images/cardImg2.webp";

import cardTabImg1 from "../../images/v4/aiFeatures/aiSentiment/images/cardTabImg1.webp";
import cardTabImg2 from "../../images/v4/aiFeatures/aiSentiment/images/cardTabImg2.webp";
import cardTabImg3 from "../../images/v4/aiFeatures/aiSentiment/images/cardTabImg3.webp";

import benefit1Icon1 from "../../images/v4/aiFeatures/aiSentiment/icons/benefit1Icon1.svg";
import benefit1Icon2 from "../../images/v4/aiFeatures/aiSentiment/icons/benefit1Icon2.svg";
import benefit1Icon3 from "../../images/v4/aiFeatures/aiSentiment/icons/benefit1Icon3.svg";
import benefit1Icon4 from "../../images/v4/aiFeatures/aiSentiment/icons/benefit1Icon4.svg";
import benefit1Img from "../../images/v4/aiFeatures/aiSentiment/images/benefit1Img.webp";


const useStyles = makeStyles((theme) => ({
    commonHeroSection: {
        backgroundImage: `url(${heroSectionBg})`,
        backgroundPosition: "bottom",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        marginBottom: "-1px",
    },
    heroSection: {
        paddingTop: '120px',
        position: "relative",
        "@media only screen and (max-width: 600px)": {
            paddingTop: '0',
            paddingBottom: '0'
        }
    },
    boxes: {
        marginTop: "56px",
        width: '100%',
        display: "flex",
        gap: '24px',
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            marginTop: "20px",
            flexDirection: "column",
            gap: "12px",
        },
    },
    box: {
        gap: "16px",
        width: '20%',
        padding: "24px",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(50px)",
        "&:first-child": {
            background: "linear-gradient(105deg, #431469 0%, #8C48C3 100%)",
        },
        "&:nth-child(2)": {
            background: "linear-gradient(90deg, #074545 0%, #009F9E 100%)",
        },
        "&:last-child": {
            background: "linear-gradient(105deg, #0A2F4F 0%, #2576BB 100%)",
        },
        "@media only screen and (max-width: 600px)": {
            flex: "1",
            width: '100%',
            padding: "10px",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
        },
    },
    heroSectionContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        gap: '24px',
        textAlign: 'center',
        "& span": {
            background:
                "linear-gradient(93deg, #058ED6 4.84%, #00BFA5 99.8%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            display: 'inline-flex',
            alignItems: 'baseline',
            justifyContent: 'flex-start',
            gap: '5px',
            "@media only screen and (max-width: 600px)": {
                "& img": {
                    height: '30px',
                    width: '30px'
                }
            }
        },

    },
    detailSection: {
        background: "linear-gradient(180deg, #210538 0%, #104F4F 100%)",
        marginBottom: "-1px",
    },
    detailCard: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        "@media only screen and (max-width: 600px)": {
            flexDirection: "column-reverse",
            gap: "40px",
        },
    },
    detailCardLeft: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: "20px",
        width: "38%",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            "&.card2": {
                width: "100%",
            },
        },
    },
    detailCardRight: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: "20px",
        width: "48%",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },
    accordianTabs: {
        backgroundImage: `url(${accordianTabsBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        marginBottom: "-1px",
        "& .headercenterContainer": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "64px",
            textAlign: 'center',
            gap: "30px",
            "& h2": {
                width: "100%",
            },
            "& p": {
                width: "100%",
            },
            "@media (max-width:768px)": {
                flexDirection: "column",
                gap: "18px",
                marginBottom: "55px",
                "& h2": {
                    width: "100%",
                },
                "& p": {
                    width: "100%",
                },
            },
        },
    },
    absoulteCard: {
        position: "absolute",
        margin: "0 auto",
        width: "100%",
        top: "-20%",
        "@media only screen and (max-width: 600px)": {
            top: "-15%",
        },
    },
    tabsSection: {
        backgroundImage: `url(${tabsSectionBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        paddingTop: "300px",
        "& .centerContainer": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "32px",
            width: "100%",
            margin: "0 auto",
            textAlign: "center",
        },
        "& $supportBox": {
            position: "absolute",
            top: "-530px",
            "@media only screen and (max-width: 600px)": {
                top: "-800px",
                marginTop: 0,
            },
        },
        "@media only screen and (max-width: 600px)": {
            paddingTop: "120px",
            "& .centerContainer": {
                width: "100%",
            },
        },
    },
    tabsContainer: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px",
        border: "2px solid #DBDBDB",
        borderRadius: "40px",
        background: "#fff",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "10px",
            padding: "5px",
            overflow: "auto",
            "&::-webkit-scrollbar": {
                display: "none",
            },
        },
    },
    tab: {
        width: "33%",
        background: "",
        padding: "18px",
        background: "transparent",
        borderRadius: "40px",
        background: "transparent",
        transition: "0.3s ease",
        cursor: "pointer",
        "&.active": {
            color: "white",
            background:
                "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
        },
        "@media only screen and (max-width: 600px)": {
            minWidth: "max-content",
            padding: "10px 15px",
        },
    },
    tabCard: {
        marginTop: "65px",
        gap: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        "@media only screen and (max-width: 600px)": {
            marginTop: "30px",
            flexDirection: "column",
        },
    },
    tabCardLeftContainer: {
        width: "50%",
        display: "flex",
        gap: "40px",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        "@media only screen and (max-width: 600px)": {
            gap: "20px",
            width: "100%",
        },
    },
    tabCardRightContainer: {
        width: "50%",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },

    tabListContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "30px",
        marginTop: "50px",
        "@media only screen and (max-width: 600px)": {
            gap: "15px",
            marginTop: "20px",
        },
    },
    tabListItem: {
        display: "flex",
        width: "100%",
        margin: "0 auto",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "15px",
        position: "relative",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "15px",
            alignItems: "flex-start",
        },
    },
    tabListItemContent: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "10px",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },
    wpFaq: {
        // paddingTop: "120px",
        "@media only screen and (max-width: 600px)": {
            "& section": {
                padding: "0px 0 0 !important",
            },
        },
    },
    commonPageFooterSection: {
        background:
            " linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
        "& .centerContainer": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "32px",
            width: "100%",
            margin: "0 auto",
            textAlign: "center",
        },
        "@media only screen and (max-width: 600px)": {
            "& .centerContainer": {
                width: "100%",
            },
        },
    },
    benefitSection: {
        backgroundImage: `url(${benefitSectionBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        paddingBottom: "260px",
        "& .centerContainer": {
            width: "100%",
            textAlign: "left",
            display: "flex",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "flex-start",
            margin: "0 auto",
            gap: "30px",
            "& h2": {
                width: "50%",
            },
            "& p": {
                width: "40%",
            },
            "@media (max-width:768px)": {
                flexDirection: "column",
                gap: "18px",
                marginBottom: "55px",
                "& h2": {
                    width: "100%",
                },
                "& p": {
                    width: "100%",
                },
            },
        },
        "& .trustedHeading": {
            width: "80%",
            textAlign: "center",
            margin: "0 auto",
            "@media only screen and (max-width: 600px)": {
                width: "100%",
            },
        },
        "@media only screen and (max-width: 600px)": {
            paddingBottom: "210px",
        },
    },
    benefitContainer: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start",
        alignItems: "stretch",
        gap: "24px",
        rowGap: "24px",
        marginTop: "60px",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "32px",
        },
    },
    benefitBox: {
        display: "flex",
        background: "linear-gradient(292deg, rgba(15, 56, 91, 0.40) 0%, rgba(47, 140, 218, 0.40) 100%)",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "24px",
        width: "32%",
        padding: "24px",
        borderRadius: "16px",
        transition: "0.3s ease",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "12px",
            padding: "16px",
        },
        // "&:hover": {
        //   transition: "0.3s ease",
        //   background: "linear-gradient(117deg, #F2E1FF 0.97%, #E9FFFF 100%)",
        //   "@media only screen and (max-width: 600px)": {
        //     "&:hover": {
        //       background: "transparent",
        //     },
        //   },
        // },
    },
    partnerSlide: {
        width: "144px !important",
        "& img": {
            width: "144px",
            filter: "brightness(1)",
        },
        "@media only screen and (max-width: 600px)": {
            width: "max-content !important",
            "& img": {
                width: "100px",
            },
        },
    },
    partnerSlider: {
        padding: "10px 0 60px !important",
        "@media only screen and (max-width: 600px)": {
            paddingBottom: "40px !important",
        },
    },
    growingBusiness: {
        backgroundImage: `url(${growingBusinessBg})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        paddingBottom: "80px",
        position: "relative",
        "& .header": {
            width: "55%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            textAlign: "left",
            gap: "32px",
        },
        "& $featureContainer": {
            gap: "20px",
        },
        "@media only screen and (max-width: 600px)": {
            paddingBottom: "50px",
            "& .header": {
                width: "100%",
            },
        },
    },
    broadcastContainerInner: {
        gap: "30px",
        width: "100%",
        display: "flex",
        padding: "0 16rem 0rem 16rem",
        paddingTop: "10px  !important",
        paddingBottom: "10px  !important",
        alignItems: "stretch",
        justifyContent: "flex-start",
        "& swiper-wrapper": {
            alignItems: "stretch !important",
        },

        "& $featureContainer": {
            width: "31%",
            height: "auto  !important",
        },
        "@media only screen and (max-width: 600px)": {
            padding: "0 15px !important",
            paddingBottom: "10px !important",
        },
        "@media only screen and (min-width: 1900px)": {
            paddingLeft: "23rem !important",
            paddingRight: "23rem !important",
        },
    },
    featureContainer: {
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "32%",
        gap: "22px",
        boxShadow: "0px 0px 16px #C1D7DB66",
        borderRadius: "16px",
        background: "#fff",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        textAlign: "left",
        "& p": {
            width: "90%",
        },
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            "& p": {
                width: "100%",
            },
        },
    },
    trustedSection: {
        "& .trustedHeading": {
            textAlign: 'center'
        }
    },
    benefitSection1: {
        background: "#F7F1FB",
        "& .centerContainer": {
            display: "flex",
            justifyContent: "space-between",
            gap: "32px",
            width: "100%",
            margin: "0 auto",
            // textAlign: "center",
            "& h2": {
                flex: 1,
            },
            "& p": {
                flex: 1,
            },
        },
        "@media only screen and (max-width:  768px)": {
            "& .centerContainer": {
                flexDirection: "column",
            },
        },

        "& .benefits": {
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
            margin: "60px 0",
            "& .imageColumn": {
                width: "94.5%",

                "& img": {
                    width: "100%",
                },
            },

            "& .featureColumn": {
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                width: "92%",
                "& .featureContainer": {
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    width: "100%",
                    gap: "22px",
                    boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.15)",
                    borderRadius: "16px",
                    background: "#fff",
                    padding: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    textAlign: "left",
                    marginBottom: "0",
                    minHeight: "48%",
                    "& p": {
                        // color: $black2,
                        width: "90%",
                    },
                    "@media only screen and (max-width: 600px)": {
                        width: "100%",
                        minHeight: "0",
                        "& p": {
                            width: "100%",
                        },
                    },
                },
            },

            "@media only screen and (max-width:  768px)": {
                flexDirection: "column",
                gap: "20px",
                marginBottom: "0",

                "& .imageColumn": {
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                },

                "& .featureColumn": {
                    width: "100%",
                },
            },
        },
    },

    //tabscards
    cardTabsSection: {
        marginBottom: "-1px",
        background: "linear-gradient(180deg, #011C33 0%, #210538 100%)",
        "& .header": {
            display: 'flex',
            marginBottom: '64px',
            width: '100%',
            "& span": {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: '5px',
                "@media only screen and (max-width: 600px)": {
                    "& img": {
                        height: '30px',
                        width: '30px'
                    }
                }
            }
        }
    },
    cardTabsContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: '24px',
        width: '100%'
    },
    cardTabsSelectors: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '30px',
        "@media only screen and (max-width: 600px)": {
            overflow: 'auto',
            gap: '15px',
            justifyContent: 'flex-start',
            "&::-webkit-scrollbar": {
                display: "none",
            },
        }
    },
    cardTabsSelector: {
        background: "rgba(255, 255, 255, 0.10)",
        padding: '24px',
        width: '32%',
        borderRadius: '16px',
        color: '#fff',
        opacity: '0.5',
        transition: '0.3s ease',
        border: '2px solid transparent',
        cursor: 'pointer',
        textAlign: 'center',
        "&.active": {
            opacity: '1',
            background: 'linear-gradient(105deg, rgba(77, 0, 140, 0.50) 0%, rgba(181, 93, 251, 0.50) 100%)',
            border: '2px solid rgba(255, 255, 255, 0.50)',
        },
        "@media only screen and (max-width: 600px)": {
            width: 'max-content',
            minWidth: "max-content",
            padding: '12px 8px',
            borderWidth: '1px',
            borderRadius: '6px',
            "&.active": {
                borderWidth: '1px',
            }

        }
    },
    cardTab: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: "24px 64px",
        borderRadius: '12px',
        background: "linear-gradient(105deg, rgba(77, 0, 140, 0.50) 0%, rgba(181, 93, 251, 0.50) 100%)",
        "@media only screen and (max-width: 600px)": {
            padding: '20px',
            flexDirection: 'column'
        }
    },
    cardTabLeft: {
        width: '30%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: '16px',
        "@media only screen and (max-width: 600px)": {
            width: '100%'
        }
    },
    cardTabRight: {
        width: '65%',
        "@media only screen and (max-width: 600px)": {
            width: '100%'
        }
    },
    //tabscards

    //hovercards

    hoverCardSection: {
        marginBottom: "-1px",
        background: 'linear-gradient(180deg, #021D1D 0%, #011C33 100%)',
        "& .header": {
            display: 'flex',
            marginBottom: '64px',
            width: '100%',
            gap: '32px',
            flexDirection: 'column',
            "& h2": {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: '5px'
            },
            "& p": {
                width: '80%'
            },
            "@media only screen and (max-width: 600px)": {
                marginBottom: '40px',
            }
        }
    },

    hoverCardContianer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '30px',
        "@media only screen and (max-width: 600px)": {
            flexDirection: 'column',
            gap: '20px'
        }
    },

    hoverCard: {
        background: "linear-gradient(105deg, rgba(10, 47, 79, 0.35) 0%, rgba(37, 118, 187, 0.35) 100%)",
        padding: '16px 24px',
        width: '32%',
        gap: '24px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        borderRadius: '12px',
        opacity: '0.5',
        transition: '0.3s ease',
        cursor: 'pointer',
        textAlign: 'left',
        transform: 'scale(1)',
        "&:hover": {
            transform: 'scale(1.1)',
            opacity: '1',
            // padding: '28px 24px',
            background: 'linear-gradient(105deg, #0A2F4F 0%, #2576BB 100%)',
        },
        "@media only screen and (max-width: 600px)": {
            width: '100%',
             opacity: '1',
             background: 'linear-gradient(105deg, #0A2F4F 0%, #2576BB 100%)',
            "&:hover": {
                transform: 'scale(1)',
            }
        }
    },

    cardsSection: {
        background: '#021D1D',
        marginBottom: "-1px",
        "& .cardImg": {
            "& img": {
                width: '100%',
                height: '100%'
            }
        },
        "@media only screen and (max-width: 600px)": {
            "& .cardImg": {
                width: '100%',
                height: '100%',
                marginBottom: "15px",
                marginTop: "0",
                "& img": {
                    width: '100%',
                    height: '100%'
                }
            }
        }
    },
    belowText: {
        width: "100%",
        textAlign: "right",
        color: "#6691b7",
        marginTop: "20px",
    },

    //hovercards


}));

const AiSentiment = () => {

    // desclaration
    const classes = useStyles();
    const [activeRealWorld, setActiveRealWorld] = useState(0);
    const [cardTabSelector, setCardTabSelector] = useState(0)

    //scrollableCards
    useEffect(() => {
        const cards = document.querySelectorAll(".card");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const card = entry.target;
                    const currentIndex = Array.from(cards).indexOf(card);

                    if (entry.isIntersecting) {
                        // Remove all previous classes first
                        cards.forEach((c) => {
                            c.classList.remove(
                                "is-previous-1",
                                "is-previous-2",
                                "is-previous-3",
                                "is-previous-4"
                            );
                        });

                        // Add appropriate classes based on distance from current card
                        cards.forEach((c, index) => {
                            if (index < currentIndex) {
                                const difference = currentIndex - index;
                                if (difference <= 4) {
                                    // Only apply effects to 4 cards back
                                    c.classList.add(`is-previous-${difference}`);
                                }
                            }
                        });
                    }
                });
            },
            {
                root: null,
                threshold: 0.5,
                rootMargin: "0px",
            }
        );

        cards.forEach((card) => observer.observe(card));

        return () => observer.disconnect();
    }, []);
    //scrollableCards


    // data

    const tabContentData = [
        {
            tabContent: [
                {
                    title: "Spot warm leads",
                    content: "Identify warm leads based on conversation tone.",
                    alt: "AI CRM for Sales Teams",
                },
                {
                    title: "Smart follow-ups",
                    content: "Prioritise follow-ups with high-intent prospects.",
                    alt: "AI CRM for Sales Teams",
                },
                {
                    title: "Personalised pitching",
                    content: "Tailor pitch based on emotional cues.",
                    alt: "AI CRM for Sales Teams",
                },
                {
                    title: "Boost conversions",
                    content: "Improve conversions by focusing on engaged leads.",
                    alt: "AI CRM for Sales Teams",
                },
            ],
            img: realWorldImg2,
            alt: "AI CRM for Sales Teams",
            subtitle:
                "Sales reps rely on signals to know when to act. Sentiment analysis highlights emotional engagement, so your team can spend time on leads that are truly ready to convert.",
        },
        {
            tabContent: [
                {
                    title: "Campaign feedback",
                    content: "Analyse feedback sentiment from campaigns.",
                    alt: "AI CRM for Marketing Teams",
                },
                {
                    title: "Emotional triggers",
                    content: "Understand emotional triggers in lead responses.",
                    alt: "AI CRM for Marketing Teams",
                },
                {
                    title: "Message resonance",
                    content: "Identify which messages resonate best.",
                    alt: "AI CRM for Marketing Teams",
                },
                {
                    title: "Impactful messaging",
                    content: "Optimise messaging for emotional impact.",
                    alt: "AI CRM for Marketing Teams",
                },
            ],
            img: realWorldImg3,
            alt: "AI CRM for Marketing Teams",
            subtitle:
                "Marketing teams craft messages, but sentiment shows which ones truly land. Know what tone connects — and what falls flat.",
        },
        {
            tabContent: [
                {
                    title: "Spot frustration",
                    content: "Detects unresolved frustration after ticket closure.",
                    alt: "AI CRM for Support Teams",
                },
                {
                    title: "Fast Escalation",
                    content: "Escalate emotionally charged cases faster.",
                    alt: "AI CRM for Support Teams",
                },
                {
                    title: "Agent coaching",
                    content: "Coach agents using real emotional insights.",
                    alt: "AI CRM for Support Teams",
                },
                {
                    title: "Boost satisfaction",
                    content: "Improve overall support satisfaction.",
                    alt: "AI CRM for Support Teams",
                },
            ],
            img: realWorldImg2,
            alt: "AI CRM for Support Teams",
            subtitle: "Support teams solve issues, but tone tells you if the experience felt resolved. With sentiment tags, your team can close the loop with confidence.",
        },
        {
            tabContent: [
                {
                    title: "Monitor tone trends",
                    content: "Track tone shifts across touchpoints.",
                    alt: "AI CRM for Success Teams",
                },
                {
                    title: "Churn warnings",
                    content: "Spot early signs of customer churn.",
                    alt: "AI CRM for Success Teams",
                },
                {
                    title: "Targeted outreach",
                    content: "Personalise outreach based on sentiment history.",
                    alt: "AI CRM for Success Teams",
                },
                {
                    title: "Stronger retention",
                    content: "Strengthen retention through empathetic engagement.",
                    alt: "AI CRM for Success Teams",
                },
            ],
            img: realWorldImg4,
            alt: "AI CRM for Success Teams",
            subtitle: "For customer success, emotion often predicts loyalty. Sentiment analysis helps your team stay a step ahead of churn risks.",
        },
    ];

    const benefits = [
        {
            title: "Built-in AI sentiment analysis",
            desc: "Turns closed conversations into insights you can act on immediately. No switching tabs, no extra effort.",
            icon: benefitIcon1,
        },
        {
            title: "Trusted by SMEs",
            desc: "Trusted CRM for fast-growing small and mid-sized businesses across industries. Used by teams that value clarity and speed.",
            icon: benefitIcon2,
        },
        {
            title: "Easy to use",
            desc: "Intuitive design that helps your team work faster and stay focused. Every feature is built to support daily workflows.",
            icon: benefitIcon3,
        },
        {
            title: "SME-friendly pricing",
            desc: "Affordable AI tools that deliver practical results without bloated pricing. Perfect for SME budgets.",
            icon: benefitIcon4,
        },
        {
            title: "All-in-one AI WhatsApp CRM",
            desc: "Complete CRM that merges automation, data, and emotional intelligence. Everything you need to grow in one place.",
            icon: benefitIcon5,
        },
        {
            title: "Privacy first",
            desc: "Privacy- Keeps customer data secure and compliant always. Built with care, scaled with confidence.",
            icon: benefitIcon6,
        },
    ];

    const partners = [
        { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
        { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
        { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
        { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
        {
            icon: partnerIcon6,
            alt: "mustard seed systems corporation - Pepper Cloud Customer",
        },
        {
            icon: partnerIcon7,
            alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
        },
        { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
        { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
        { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
        { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
        { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
        {
            icon: partnerIcon6,
            alt: "mustard seed systems corporation - Pepper Cloud Customer",
        },
        {
            icon: partnerIcon7,
            alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
        },
        { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    ];

    const faqs = [
        {
            question: "What is sentiment analysis in AI?",
            answer:
                "It is a process where AI evaluates text to identify the emotional tone behind it. This helps businesses understand how customers feel, not just what they write.",
        },
        {
            question: "How to use Gen AI for sentiment analysis?",
            answer:
                "Generative AI can be trained to analyse patterns in text and detect emotional sentiment. In Pepper Cloud, this is built into the CRM system, no training required.",
        },
        {
            question: "What is AI sentiment analysis?",
            answer:
                "It is the use of artificial intelligence to classify whether a message is positive, neutral, negative, or any predefined sentiments.",
        },
        {
            question: "How does AI sentiment analysis work?",
            answer:
                "In Pepper Cloud CRM system, once a conversation ends, AssistAI analyses the language and tags the closed session with a sentiment score.",
        },
        {
            question: "Which application of AI is used for customer sentiment analysis?",
            answer:
                "Natural Language Processing (NLP) is the main AI technique used for this customer sentiment analysis.",
        },
        {
            question: "How to do sentiment analysis?",
            answer:
                "You don’t need to do anything manually. Once the feature is enabled, Pepper Cloud AssistAI handles it automatically.",
        },
    ];

    const cardTabs = [
        {
            tabName: "Predefine sentiment labels",
            heading: "Predefine sentiment labels",
            text: "Create your list of preferred sentiment tags such as happy, neutral, angry, and more, so your CRM AI knows what to look for. These labels become the foundation for analysis, helping tailor insights to your business language.",
            image: cardTabImg1,
            alt: "AssistAI tagging emotional tone in customer conversations"
        },
        {
            tabName: "Create automated workflows",
            heading: "Create automated workflows",
            text: "Automatically trigger AI sentiment analysis every time a conversation is closed. No manual action needed, just configure once and let the AssistAI analyse the chat and tag the emotional tone instantly.",
            image: cardTabImg2,
            alt: "Sales and support teams using AI-driven sentiment analysis"
        },
        {
            tabName: "Tag sentiment to conversations",
            heading: "Tag sentiment to conversations",
            text: "Every time a conversation session is close, AssistAI auto-analyses the sentiment and attaches it to the conversation thread. Every closed chat or email comes with a clear emotional label your team can use to take smarter, more empathetic action.",
            image: cardTabImg3,
            alt: "Pepper Cloud CRM analysing customer sentiment using AI"
        },
    ]

    const hoverCardCard = [
        {
            heading: "86%",
            text: "Pay more for experience",
        },
        {
            heading: "80%",
            text: "Experience equals product value",
        },
        {
            heading: "25%",
            text: "Higher satisfaction scores",
        }
    ]

    const capabilities = [
        {
            heading: "Identify high-intent leads easily with AI sentiment analysis",
            desc: "With Pepper Cloud AI sentiment analysis, every closed conversation is automatically analysed to detect whether the tone was positive, neutral or negative, giving you the context that really matters.\n\nSpot emotionally engaged leads based on tone. Prioritise timely follow-ups. Close more deals by focusing on warm prospects.",
            // video: cardSectionVideo1,
            // background: "linear-gradient(180deg, #00B69E 0%, #0131A1 100%)",
            backgroundImage: cardBg1,
            img: cardImg1,
            alt: "AI sentiment analysis dashboard"
        },
        {
            heading: "What is AI sentiment analysis?",
            desc: "AI sentiment analysis helps you understand how customers feel after every interaction. It uses natural language processing (NLP) to automatically tag conversations with sentiments. Pepper Cloud AssistAI sentiment analysis feature automatically works behind the scenes once a conversation ends — so you can track sentiment trends, prioritise follow-ups, and make data-backed improvements to your customer experience.",
            // video: cardSectionVideo2,
            // background: "linear-gradient(180deg, #8E32C3 0%, #660DAE 100%)",
            backgroundImage: cardBg2,
            img: cardImg2,
            alt: "AssistAI tagging emotional tone in customer conversations"
        },
    ];


    return (
        <main>
            <SEO
                title={
                    "AI-Driven Sentiment Analysis for Sales & Support Teams | Pepper Cloud"
                }
                pathname={
                    "https://peppercloud.com/best-ai-crm-features/ai-chatbot-for-crm/"
                }
                keywords="AI sentiment analysis, AI text sentiment analysis, Best AI sentiment analysis tools, AI-driven sentiment analysis tools, Customer sentiment analysis"
                description={"Analyse customer emotions with AI sentiment analysis with Pepper Cloud CRM. Discover how Pepper Cloud CRM uses AI text sentiment analysis to track emotional trends, identify high-intent leads, and reduce customer churn."}
                ogData={{
                    "og:image": [
                        "/meta/og/1X1/home.png",
                        "/meta/og/1024X512/home.png",
                        "/meta/og/1200X630/home.png",
                    ],
                }}
                jsonLd={[
                    {
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        name: "Pepper Cloud",
                        legalName: "Pepper Cloud PTE LTD",
                        url: "https://peppercloud.com/",
                        logo: "https://peppercloud.com/icons/logo.png",
                        foundingDate: "2017",
                        address: [
                            {
                                "@type": "PostalAddress",
                                streetAddress: "#04-01/02",
                                addressLocality: "Blk 79 Ayer Rajah Crescent",
                                addressRegion: "SG",
                                postalCode: "139955",
                                addressCountry: "Singapore",
                            },
                            {
                                "@type": "PostalAddress",
                                streetAddress:
                                    "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                                addressLocality: "Bengaluru",
                                addressRegion: "KA",
                                postalCode: "560095",
                                addressCountry: "India",
                            },
                        ],
                        contactPoint: {
                            "@type": "ContactPoint",
                            contactType: "customer support",
                            telephone: "+6566562616",
                            email: ["sales@peppercloud.com", "support@peppercloud.com"],
                        },
                        sameAs: [
                            "https://twitter.com/peppercloudpte",
                            "https://www.linkedin.com/company/peppercloud/",
                            "https://www.facebook.com/PepperCloudPteLtd",
                            "https://www.instagram.com/pepper.cloud/",
                        ],
                    },
                    {
                        "@context": "https://schema.org",
                        "@type": "VideoObject",
                        name: "AssistAI",
                        description:
                            "Harness the power of Pepper Cloud's AssistAI to simplify conversations, automate tasks, streamline workflows, and more. Save time, improve productivity, and make smarter sales decisions with the best AI CRM for your sales workflow.",
                        thumbnailUrl: [
                            "https://drive.google.com/file/d/11D38QAsWjwxtUae6YnwdP1Y__tusgmRF/view?usp=drive_link",
                        ],
                        uploadDate: "2024-12-02",
                        contentUrl:
                            "https://peppercloud.com/static/aiPageHeroSection-3907c41f7c08dfe21633f203852eebe2.mp4",
                        publisher: {
                            "@type": "Organization",
                            name: "Pepper Cloud",
                            logo: {
                                "@type": "ImageObject",
                                url: "https://d4.alternativeto.net/TylnV9uYJt3KRkoH7m9Qbm-T2kdjqV4X3JgKsTxbTUs/rs:fit:280:280:0/g:ce:0:0/exar:1/YWJzOi8vZGlzdC9pY29ucy9wZXBwZXItY2xvdWQtY3JtXzI0MzM4NS5wbmc.png",
                                width: "",
                                height: "",
                            },
                        },
                        duration: "PT1M12S",
                    },
                    {
                        "@context": "https://schema.org/",
                        "@type": "FAQPage",
                        mainEntity: [
                            {
                                "@type": "Question",
                                name: "What is sentiment analysis in AI?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "It is a process where AI evaluates text to identify the emotional tone behind it. This helps businesses understand how customers feel, not just what they write.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "How to use Gen AI for sentiment analysis?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Generative AI can be trained to analyse patterns in text and detect emotional sentiment. In Pepper Cloud, this is built into the CRM system, no training required.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "What is AI sentiment analysis?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "It is the use of artificial intelligence to classify whether a message is positive, neutral, negative, or any predefined sentiments.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "How does AI sentiment analysis work?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "In Pepper Cloud CRM system, once a conversation ends, AssistAI analyses the language and tags the closed session with a sentiment score.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Which application of AI is used for customer sentiment analysis?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Natural Language Processing (NLP) is the main AI technique used for this customer sentiment analysis.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "How to do sentiment analysis?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "You don’t need to do anything manually. Once the feature is enabled, Pepper Cloud AssistAI handles it automatically.",
                                },
                            }
                        ],
                    },
                ]}
            />
            <section className={classes.commonHeroSection}>
                <section className={classes.heroSection}>
                    <div className='container'>
                        <div className={classes.heroSectionContainer}>
                            <motion.h1
                                initial={{ opacity: 1, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5 }}
                                className="font-wix-semibold font-white font-64"> Turn closed conversations into insights with <span> <LazyImage source={aiIcon} alt={"AssistAi - Ai crm"} />AI sentiment analysis</span></motion.h1>
                            <motion.p initial={{ opacity: 1, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5 }} className='font-white font-wix-regular font-20'>Understand the emotional tone behind every closed conversation with Pepper Cloud AI sentiment analysis. Enable your team to respond thoughtfully, learn continuously, and boost client retention.</motion.p>
                            <Link to="/contact/" className="font-18 font-white font-wix-regular primaryButton">Book a free demo</Link>
                            <div className={classes.boxes}>
                                <div className={classes.box}>
                                    <img src={heroIcon1} alt="Pepper Cloud CRM analysing customer sentiment using AI" />
                                    <p className="font-18 font-wix-medium font-white">
                                        Track sentiment trends across chats
                                    </p>
                                </div>
                                <div className={classes.box}>
                                    <img src={heroIcon2} alt="Customer sentiment trends across closed conversations in AI CRM" />
                                    <p className="font-18 font-wix-medium font-white">
                                        Prioritise follow-ups smartly
                                    </p>
                                </div>
                                <div className={classes.box}>
                                    <img src={heroIcon3} alt="AI sentiment analysis dashboard" />
                                    <p className="font-18 font-wix-medium font-white">
                                        Train your team using real interactions
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className={classes.trustedSection}>
                    <div className='container'>
                        <div className="trustedHeading">
                            <motion.h3
                                initial={{ opacity: 1, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                className="font-wix-semibold font-24 font-white"
                            >
                                Trusted by leading businesses for outstanding efficiency
                            </motion.h3>
                        </div>
                    </div>
                    <Swiper
                        className={classes.partnerSlider}
                        slidesPerView="auto"
                        spaceBetween={60}
                        loop={true}
                        speed={2000}
                        modules={[Autoplay]}
                        allowTouchMove={false}
                        autoplay={{
                            delay: 100,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: false,
                        }}
                    >
                        {partners.map((partner) => (
                            <SwiperSlide className={classes.partnerSlide}>
                                <img src={partner.icon} alt={partner.alt} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </section>
            </section>

            <section className={classes.cardsSection}>
                <div className="container">
                    {/* <div className="centerHeader">
                        <p className="font-18 font-wix-semibold font-white">Features</p>
                        <motion.h2
                            initial={{ opacity: 1, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            className="font-wix-medium font-56 gradientHeading"
                        >
                            Accelerate sales success with advanced AssistAI{" "}
                            <img src={glareIcon} alt={"AI automation"} /> capabilities
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            className="font-wix-regular font-18 color-black5 mt10"
                        >
                            Experience the power of AssistAI, the intelligent generative AI
                            within Pepper Cloud CRM, designed to streamline your
                            communication and enhance customer engagement. From handling
                            customer queries to automating workflows and simplifying task
                            management, AssistAI empowers your team to deliver efficient
                            support, close deals faster, and scale your business.
                        </motion.p>
                    </div> */}
                    <ul id="cards">
                        {capabilities.map((data, index) => (
                            <li className="card" id={`card-${index + 1}`}>
                                <div
                                    className="card-content"
                                    style={{ backgroundImage: `url(${data.backgroundImage})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}
                                >
                                    <div className="cardImg">
                                        <img alt={data.alt} src={data.img} />
                                    </div>
                                    <div className="cardContentData">
                                        <h3 className="cardHeading font-wix-medium">
                                            {data.heading}
                                        </h3>
                                        <p className="cardDesciption">{data.desc}</p>
                                    </div>

                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
            <section className={classes.hoverCardSection}>
                <div className='container'>
                    <div className="header">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            Boost customer experience with AI-driven sentiment analysis
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-20 font-white"
                        >
                            Let your team focus on what matters. An AI-powered knowledge base gives quick answers from your documents, manuals, and links—right inside the CRM
                        </motion.p>
                    </div>
                    <div className={classes.hoverCardContianer}>
                        {hoverCardCard.map((card) => (
                            <div className={classes.hoverCard}>
                                <h3 className='font-64 font-white font-wix-bold'>{card.heading}</h3>
                                <p className='font-18 font-white font-semibold'>{card.text}</p>
                            </div>
                        ))}
                    </div>
                    <div className={classes.belowText}>
                        <p className="font-12 font-wix-regular">
                            * Statistics from multiple sources
                        </p>
                    </div>
                </div>
            </section>
            <section className={classes.cardTabsSection}>
                <div className='container'>
                    <div className="header">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            Turn conversations into emotional <span>intelligence <LazyImage source={smileIcon} alt={"AssistAi - Ai crm"} /></span>
                        </motion.h2>
                    </div>
                    <div className={classes.cardTabsContainer}>
                        <div className={classes.cardTabsSelectors}>
                            {cardTabs.map((tab, i) => (
                                <div className={clsx(classes.cardTabsSelector, 'font-18', 'font-wix-semibold', cardTabSelector === i && 'active')} onClick={() => setCardTabSelector(i)} >{tab.tabName}</div>
                            ))}
                        </div>
                        {cardTabs.map((tab, i) => (
                            cardTabSelector === i && <div className={classes.cardTab}>
                                <div className={classes.cardTabLeft}>
                                    <p className='font-24 font-wix-semibold font-white'>{tab.tabName}</p>
                                    <p className='font-18 font-wix-regular font-white'>{tab.text}</p>
                                </div>
                                <div className={classes.cardTabRight}>
                                    <LazyImage source={tab.image} height={"100%"} width={"100%"} alt={tab.alt} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className={classes.detailSection}>
                <div className="container">
                    <div className={classes.detailCard}>
                        <div className={classes.detailCardRight}>
                            <motion.p
                                initial={{ opacity: 1, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                className="font-wix-semibold font-20 font-white"
                            >
                                AssistAI
                            </motion.p>
                            <motion.h2
                                initial={{ opacity: 1, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                className="font-wix-semibold font-56 font-white"
                            >
                                One AI CRM system, endless smart actions
                            </motion.h2>
                            <motion.p
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.3 }}
                                className="font-wix-regular font-18 font-white"
                            >
                                From sentiment tagging to workflow triggers, let AI handle the
                                repetitive stuff. You focus on decisions — your CRM takes care
                                of the data.
                            </motion.p>
                        </div>
                        <div className={classes.detailCardLeft}>
                            <LazyImage
                                width={"100%"}
                                source={detailImg2}
                                alt="AI CRM for marketing teams"
                            />
                        </div>

                    </div>
                </div>
            </section>
            <section className={classes.benefitSection1}>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 "
                        >
                            Benefits of customer sentiment analysis
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-20 "
                        >
                            Get quick, actionable insights from every interaction. No more guesswork, just a clear emotional context your team can use immediately.
                        </motion.p>
                    </div>

                    <div className="benefits">
                        <div className="featureColumn">
                            <div className="featureContainer">
                                <LazyImage
                                    source={benefit1Icon1}
                                    alt={"Instant sentiment score"}
                                    className={classes.featureIcon}
                                />
                                <p className="font-wix-semibold font-24 color-black2">
                                    Instant sentiment score
                                </p>
                                <p className="font-wix-medium font-18 color-black3">
                                    Quickly understand how a conversation ended, positive, neutral or negative, without reading through the entire thread.
                                </p>
                            </div>

                            <div className="featureContainer">
                                <LazyImage
                                    source={benefit1Icon2}
                                    alt={"Conversation summary with tone tags"}
                                    className={classes.featureIcon}
                                />
                                <p className="font-wix-semibold font-24 color-black2">
                                    Conversation summary with tone tags
                                </p>
                                <p className="font-wix-medium font-18 color-black3">
                                    Get a concise emotional summary for every chat, email, or interaction, automatically added to the customer’s profile.
                                </p>
                            </div>
                        </div>

                        <div className="imageColumn">
                            <LazyImage
                                source={benefit1Img}
                                alt={"Pepper Cloud CRM analysing customer sentiment using AI"}
                            // alt={listItem.alt}
                            />
                        </div>

                        <div className="featureColumn">
                            <div className="featureContainer">
                                <LazyImage
                                    source={benefit1Icon3}
                                    alt={"Sentiment trends over time"}
                                    className={classes.featureIcon}
                                />
                                <p className="font-wix-semibold font-24 color-black2">
                                    Sentiment trends over time
                                </p>
                                <p className="font-wix-medium font-18 color-black3">
                                    Spot patterns in how your customers are feeling over multiple touchpoints, so you can respond with care and strategy.
                                </p>
                            </div>

                            <div className="featureContainer">
                                <LazyImage
                                    source={benefit1Icon4}
                                    alt={"Coaching-ready insights"}
                                    className={classes.featureIcon}
                                />
                                <p className="font-wix-semibold font-24 color-black2">
                                    Coaching-ready insights
                                </p>
                                <p className="font-wix-medium font-18 color-black3">
                                    Help your team improve with real examples. Use past conversations to show what worked, what didn’t, and how to handle tricky situations better.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className={classes.benefitSection}>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            Pepper Cloud: The best CRM for AI sentiment analysis
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-18 font-white"
                        >
                            Whether you're scaling your team or refining your workflows, Pepper Cloud gives you the emotional intelligence edge. With built-in AI sentiment analysis, every closed conversation becomes an opportunity to improve service, sales, and retention.
                        </motion.p>
                    </div>
                    <div className={classes.benefitContainer}>
                        {benefits.map((benefit) => (
                            <div className={classes.benefitBox}>
                                <img
                                    src={benefit.icon}
                                    alt="Customer support automation tool"
                                />
                                <p className="font-wix-semibold font-20 font-white">
                                    {benefit.title}
                                </p>
                                <p className="font-wix-regular font-16 font-white">
                                    {benefit.desc}
                                </p>
                            </div>
                        ))}
                    </div>

                </div>
            </section>
            <section className={classes.tabsSection}>
                <div className={classes.absoulteCard}>
                    <TruestedSection shadow={true} background={true} />
                </div>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            How different teams use sentiment analysis for business growth
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-20 font-white"
                        >
                            Every team talks to customers but not every team understands how they feel. With sentiment analysis, your sales, marketing, support, and success teams can finally stop guessing and start responding with clarity, timing, and empathy.
                        </motion.p>
                        <div className={classes.tabsContainer}>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 0 && "active"
                                )}
                                onClick={() => setActiveRealWorld(0)}
                            >
                                Sales teams
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 1 && "active"
                                )}
                                onClick={() => setActiveRealWorld(1)}
                            >
                                Marketing teams
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 2 && "active"
                                )}
                                onClick={() => setActiveRealWorld(2)}
                            >
                                Support teams
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 3 && "active"
                                )}
                                onClick={() => setActiveRealWorld(3)}
                            >
                                Success teams
                            </div>
                        </div>
                    </div>
                    <div className={classes.tabCard}>
                        <div className={classes.tabCardLeftContainer}>
                            {tabContentData.map(
                                (listItem, index) =>
                                    index === activeRealWorld && (
                                        <div>
                                            <motion.p
                                                initial={{ opacity: 0, x: -20 }}
                                                whileInView={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.3 }}
                                                className="font-wix-regular font-18 font-white"
                                            >
                                                {listItem.subtitle}
                                            </motion.p>
                                            <div className={classes.tabListContainer}>
                                                {listItem.tabContent.map((item) => (
                                                    <motion.div
                                                        initial={{ opacity: 0, x: -20 }}
                                                        whileInView={{ opacity: 1, x: 0 }}
                                                        transition={{ duration: 0.3 }}
                                                        className={classes.tabListItem}
                                                    >
                                                        <LazyImage
                                                            source={greenCheckCircle}
                                                            className={classes.tabIcon}
                                                            alt={item.alt}
                                                        />
                                                        <div className={classes.tabListItemContent}>
                                                            <p className="font-wix-semibold font-18 font-white">
                                                                {item.title}:
                                                            </p>
                                                            <p className="font-wix-regular font-18 font-white">
                                                                {item.content}
                                                            </p>
                                                        </div>
                                                    </motion.div>
                                                ))}
                                            </div>
                                        </div>
                                    )
                            )}
                        </div>
                        <div className={classes.tabCardRightContainer}>
                            {tabContentData.map(
                                (listItem, index) =>
                                    index === activeRealWorld && (
                                        <motion.div
                                            initial={{ opacity: 1, y: 20 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.3 }}
                                        // className={classes.aiSectionRight}
                                        >
                                            <LazyImage
                                                source={listItem.img}
                                                alt={listItem.alt}
                                                width={"100%"}
                                            />
                                        </motion.div>
                                    )
                            )}
                        </div>
                    </div>
                </div>
            </section>
            <TestimonialSlider desc={"Discover how businesses are transforming customer engagement with Pepper Cloud."} heading={"Real stories. Real results."} noButton={true} />

            <div className={classes.wpFaq}>
                <FaqSection
                    backgroundColor={"#FFFFFF"}
                    heading={"Frequently asked questions - AI sentiment analysis"}
                    faqs={faqs}
                />
            </div>
            <section className={classes.commonPageFooterSection}>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            className="font-wix-medium font-56 font-white"
                            initial={{ opacity: 1, y: 30 }}
                            transition={{ duration: 0.5 }}
                            whileInView={{ opacity: 1, y: 0 }}
                        >
                            Know the tone. Act with clarity. Build better relationships with AssistAI
                        </motion.h2>
                        <Link
                            className="primaryButton font-20 font-wix-medium font-white"
                            to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                        >
                            Get started
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default AiSentiment